export type SnBadgePositionX = 'before' | 'after';
export type SnBadgePositionY = 'above' | 'below' | 'middle';
